import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=2421dc37&scoped=true&"
import script from "./popover.vue?vue&type=script&lang=js&"
export * from "./popover.vue?vue&type=script&lang=js&"
import style0 from "./popover.vue?vue&type=style&index=0&id=2421dc37&prod&scoped=true&lang=scss&"
import style1 from "./popover.vue?vue&type=style&index=1&id=2421dc37&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2421dc37",
  null
  
)

export default component.exports